import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

window.noUiSlider = noUiSlider
